import {
  BankAccountInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import { Col, Divider, Input, Row, Typography } from 'antd';
import React from 'react';

const RegisterDataAccountReceivable: React.FC = () => {
  return (
    <>
      <Typography.Title level={4} style={{ margin: 0 }}>
        Pesquisar por dados do registro financeiro
      </Typography.Title>

      <Divider style={{ margin: 0, marginBottom: 24 }} />

      <Row gutter={[12, 12]}>
        <Col span={24} md={8}>
          <FloatingFormItem label="Número do Documento" name="documentNumber">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Conta bancária" name="bankAccountId">
            <BankAccountInfiniteSelectField
              allowClear
              queryFilter={{ active: true }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Centro de Custo" name="costCenterId">
            <CostCenterInfiniteSelectField allowClear />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
};

export default RegisterDataAccountReceivable;
